<script>
import Footer from "@/components/organisms/Footer/Component.vue"

export default {
  name: "App",

  components: {
    Footer,
    PcHeader: () => import("@/components/organisms/Header/PcComponent.vue"),
    SpHeader: () => import("@/components/organisms/Header/SpComponent.vue"),
  },

  data: () => ({
    //
  }),
}
</script>

<template>
  <v-app class="app">
    <PcHeader class="d-none d-sm-block" />
    <SpHeader class="d-block d-sm-none" />

    <v-main>
      <router-view />
    </v-main>

    <Footer />
  </v-app>
</template>

<style lang="scss">
.app {
  overflow: hidden;
}
</style>
